import { useRef, useState } from 'react';

/**
 * In some components, we'd like to support both controlled and uncontrolled state. This
 * hook simplifies supporting both.
 */
function useOptionallyControlledState({ currentValue, defaultValue, onChange }) {
    const isControlled = useRef(currentValue !== undefined);
    const [internalValue, setInternalValue] = useState(defaultValue);
    /* istanbul ignore if */
    if (process.env.NODE_ENV === "development") {
        const latestIsControlled = currentValue !== undefined;
        if (isControlled.current !== latestIsControlled) {
            throw new Error('Attempted to change state management after initial render. A component prop should either be controlled or uncontrolled; it should never switch between the two patterns.');
        }
    }
    if (isControlled.current) {
        return [currentValue, onChange];
    }
    return [internalValue, setInternalValue];
}

export { useOptionallyControlledState };
//# sourceMappingURL=useOptionallyControlledState.esm.js.map
